<template>
  <div v-if="event.contradictory_status" class="debtor-answer">
    <div class="d-flex align-center flex-wrap debtor-answer__header">
      <v-icon small color="blue-grey" class="mr-2">mdi-message-reply-text-outline</v-icon>
      <span class="text-subtitle-2 font-weight-bold mr-3">{{ title }}</span>
      <v-chip x-small label :color="status.color" text-color="white">{{ status.label }}</v-chip>
    </div>
    <v-row dense class="mt-1">
      <v-col v-if="event.contradictory_status_at" cols="12" sm="6" md="4">
        <div class="objection-field__label">Respondido em</div>
        <div class="objection-field__value">{{ $moment(event.contradictory_status_at).utc().format('DD/MM/YYYY') }}</div>
      </v-col>
      <v-col v-if="Number(event.contradictory_amount) > 0" cols="12" sm="6" md="4">
        <div class="objection-field__label">Valor reconhecido</div>
        <div class="objection-field__value objection-field__value--amount">{{ money(event.contradictory_amount) }}</div>
      </v-col>
      <v-col v-if="event.contradictory_type" cols="12" sm="6" md="4">
        <div class="objection-field__label">Classe indicada</div>
        <div class="objection-field__value">{{ classLabel(event.contradictory_type) }}</div>
      </v-col>
      <v-col v-if="reason" cols="12">
        <div class="objection-field__label">Justificativa</div>
        <div class="objection-field__text">{{ reason }}</div>
      </v-col>
      <v-col v-if="links.length" cols="12">
        <div class="objection-field__label">Documentos</div>
        <v-btn v-for="(link, index) in links" :key="link" :href="link" target="_blank" rel="noopener noreferrer"
          small outlined color="primary" class="mr-2 mt-1">
          <v-icon left small>mdi-file-document-outline</v-icon>Documento {{ index + 1 }}
        </v-btn>
      </v-col>
    </v-row>
    <div class="text-caption grey--text mt-2">A decisão sobre o pedido é da Administração Judicial.</div>
  </div>
</template>

<script>
import creditorTypes from '@/common/data/creditor-types.data';
import { plainText, formatMoney } from '@/common/util/objection-phase';

const STATUS = {
  1: { label: 'Concorda com o pedido', color: 'green darken-1' },
  2: { label: 'Não concorda com o pedido', color: 'red darken-1' },
  3: { label: 'Concorda parcialmente', color: 'indigo' },
  4: { label: 'Validado', color: 'blue-grey' },
};

// Contraditório da Recuperanda sobre a revisão do credor (Fase 2), somente leitura.
export default {
  name: 'DebtorContradictoryCard',
  props: {
    event: { type: Object, required: true },
    title: { type: String, default: 'Resposta da Recuperanda ao seu pedido' },
  },
  computed: {
    status() { return STATUS[Number(this.event.contradictory_status)] || { label: 'Registrada', color: 'blue-grey' }; },
    reason() { return plainText(this.event.contradictory_reason); },
    links() {
      let docs = this.event.contradictory_docs;
      try { if (typeof docs === 'string') docs = JSON.parse(docs); } catch (error) { docs = String(docs).split(/[\s,;]+/); }
      const list = Array.isArray(docs) ? docs : (docs ? [docs] : []);
      return list.map(item => String(item || '').trim()).filter(item => /^https?:\/\//i.test(item));
    },
  },
  methods: {
    classLabel(type) {
      const found = creditorTypes.find(item => item.id === Number(type));
      return found ? found.name : '—';
    },
    money(value) { return formatMoney(value, 1); },
  },
};
</script>

<style>
.objection-field__label { font-size: 11px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: #757575; margin-bottom: 2px; }
.objection-field__value { font-size: 14px; color: #212121; }
.objection-field__value--amount { font-size: 16px; font-weight: 700; color: #1a237e; }
.objection-field__text { font-size: 14px; color: #424242; white-space: pre-line; }
.debtor-answer { background: #f7f9fc; border: 1px solid #e3e8f0; border-radius: 8px; padding: 12px 14px; margin-top: 12px; }
</style>
